import { render, staticRenderFns } from "./AutoIndentConfirmationDialog.vue?vue&type=template&id=715bbcba&scoped=true&"
import script from "./AutoIndentConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./AutoIndentConfirmationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AutoIndentConfirmationDialog.vue?vue&type=style&index=0&id=715bbcba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715bbcba",
  null
  
)

export default component.exports